var  next_step_click, group_error = 0, cart;
function Cart() {
	var self = this;
	cart = self;
	this.cartUrl = '/cart';
	this.xhr = false;
	this.init();

	next_step_click = 0;
	$('body').on('click', '.next-step', function(e){
		e.preventDefault();
		if (next_step_click == 0) {
			next_step_click = 1;
			ajax_cart_next_step(this);
		}
	});

	//event dla wstecz lub powrotu na strone w innej zakladce
	window.addEventListener('focus', (event) => {
		getCartHash();
	});
}

function reloadAsGet() {
	var loc = window.location;
	window.location = loc.protocol + '//' + loc.host + loc.pathname + loc.search;
}

function ajax_cart() {
	var form = $('form.cart-form');
	var formUrl = form.attr('action');
	var formData = form.serialize();

	$.ajax({
		type        : 'POST',
		url         : formUrl,
		data        : formData,
		dataType    : 'json',
	}).done(function(data) {console.log('cart');
		var cartRight = $(data.html).find('.cart-right').html();
		var totalCheckout = $(data.html).find('.cart-to-checkout').find('.cart-total').find('.cart-total__sum').find('span').text();
		$('.cart-right').html(cartRight);
		$('.cart-to-checkout').find('.cart-total').find('.cart-total__sum').find('span').text(totalCheckout);
	});
}

function ajax_cart_next_step(a) {
	var url = $(a).attr('href');
	var form = $(a).closest('form');
	var formUrl = form.attr('action');
	var formData = form.serialize();
	if (!url)
		url = formUrl;
	//console.log(url);

	$.ajax({
		type        : 'POST',
		url         : url,
		data        : formData,
		dataType    : 'json',
	}).done(function(data) {
		//kasowanie komunikatow walidacji
		$('span.errorinfo').removeClass('-active');
		$('input.error').removeClass('error');
		$('.form-input-group--required.error').removeClass('error');

		//błędy walidacji
		if (data.fails) {
			if (data.cartHashDiff) {
				alert(data.cartHashDiff);
				window.location.reload();
			}
			//console.log(data.errors);
			for (var name in data.errors) {
				var span = form.find('span[data-input="'+name+'"]');
				//console.log(span.length);
				$('input[name="'+name+'"]').addClass('error');
				if (span.length) {
					span.html(data.errors[name][0]).addClass('-active').parent().addClass('error');
				}
			}
			if ($('div.error').first().length)
				$(window).scrollTop( $('div.error').first().offset().top - 120);
			next_step_click = 0;
		} else {
			//next-step
			window.location.href = url;
		}
	});
}

// todo: 
// - po dodaniu do koszyka zrobic recalc nicescroll
// - na mobilu pasek z dodawaniem do koszyka pojawia sie dopiero kiedy zniknie przycisk z cena z ekranu

Cart.prototype.init = function() {
	var self = this;
	self.handleAddToCartButtons();
	self.handleRemoveButton();
	self.handleQuantityButtons();
	self.addItems();
	self.handleMenuCartScroll();
	self.handleDeliveryRadio();
	self.handleOrderInputs();
	self.handleQuantityInput();
	self.handleCheckout();
	$('.addtocart-overlay .body-overlay__close').on('click', function() {
		$('.addtocart-overlay').removeClass('-active');
	});

	$('.cart-positions-total a').on('click', function(e){
		e.preventDefault();
		reloadAsGet();
	});
	//console.log('koszyk - init');
};

Cart.prototype.updateCart = function(oper, attributes_id, quantity, elem) {
	var self = this;

	var addedItemTitle;
	var addedItemPrice;
	var addedItemImg;
	var digital_type;
	var __addedItemTitle;

	$.ajax({
		method: 'POST',
		url: self.cartUrl,
		dataType: 'json',
		data: {oper: oper, attributes_id: attributes_id, quantity: quantity}
	}).success(function(msg) {

		//console.log(msg.hash);
		//window.localStorage.setItem('cartHash', msg.hash );

		group_error = 0;
		if (msg.group_error) {
			group_error = 1;
			alert(msg.message);
			//strona koszyka, reload jako GET
			if (msg.group_error == 1) {
				//window.location.reload();
				reloadAsGet();
			}
		}

		//duplikat cyfrowego produktu
		if (msg.duplicate) {
			group_error = 1;
			//pokaz popup
			$('#cart-duplicate').addClass('-active');
			return 0;
		}

		var data = $(msg.html).find('.navbar-cart').html();
		var productsCount = $(msg.html).find('.section-cart').attr('data-products-count');
		var total = $(msg.html).find('.cart-summary').find('.cart-summary__total').find('span').text();
		var totalCheckout = $(msg.html).find('.cart-to-checkout').find('.cart-total').find('.cart-total__sum').find('span').text();
		var savings = $(msg.html).find('.cart-positions-table-foot').find('.cart-positions-price').find('span').text();
		var savingsPercent = $(msg.html).find('.cart-positions-table-foot').find('.cart-positions-price').find('.savingsPercent').text();
		var freeDelivery = $(msg.html).find('.cart-summary__freedelivery').html();
		var overlayHtml = $(msg.html).find('.cartadded-overlay').html();
		var cartRight = $(msg.html).find('.cart-right').html();
		var country = $(msg.html).find('.country-container').html();
		var freebies = $(msg.html).find('.cart-freebies').html();

		//rabat /koszyk
		if ($('.cart-summary__discount').length)
			$('.cart-summary__discount').html( $(msg.html).find('.cart-summary__discount').html() );
		
		$('.country-container').html(country);

		if (oper == 'add') {
			
			if (typeof gtag !== 'undefined' && msg.add_google_JS) {
				gtag('event', 'add_to_cart', msg.add_google_JS);
			}

			if (typeof fbq !== 'undefined' && msg.add_facebook_JS) {
				fbq('track', 'AddToCart', {
					content_ids: msg.add_facebook_JS.content_ids,
					content_name: msg.add_facebook_JS.content_name,
					content_type: 'product',
					contents: msg.add_facebook_JS.contents,
					currency: 'PLN',
					value: parseFloat(msg.add_facebook_JS.value)
				});
			}

			if (group_error == 0) {
				$('#cart-added').empty().append(overlayHtml);
				$('#cart-added').addClass('-active');
			}
			
			if (typeof elem !== 'undefined') {
				if ($(elem).closest('.catalogue-item').length) {
					digital_type = msg.digital_type ? msg.digital_type : "";
					addedItemTitle = $(elem).closest('.catalogue-item').find('.catalogue-item__title').text();
					addedItemPrice = $(elem).closest('.catalogue-item').find('.catalogue-item-price').attr('data-price');
					addedItemImg = $(elem).closest('.catalogue-item').find('.catalogue-item-image').find('img').attr('src');
				} else if ($(elem).closest('.product-info').length) {
					digital_type = msg.digital_type ? msg.digital_type : "";
					addedItemTitle = $(elem).closest('.product-info').find('.product-info__title').text();
					addedItemPrice = $(elem).closest('.product-info').attr('data-price');
					addedItemImg = $(elem).closest('.product-wrapper').find('.product-gallery').find('[data-slick-index="0"]').find('img').attr('src');
				}
			}
			
			if (digital_type) {
				//nadpisanie ceny dla cyfrowych
				if (msg.product_price)
					addedItemPrice = msg.product_price;
				__addedItemTitle = addedItemTitle + '<br><span class="cartadded-price__digital">'+digital_type+'</span>' + '<span>'+addedItemPrice+'</span>';
			}
			else
				__addedItemTitle = addedItemTitle + '<br><span>'+addedItemPrice+'</span>';
			$('.cartadded-overlay .cartadded-price p').html(__addedItemTitle);
			$('.cartadded-overlay .cartadded-cover').attr('src', addedItemImg);	
			$('.navbar-cart').empty().append(data);
			$('.navbar-cart-quantity').html(parseInt(productsCount));
			$('.cart-freebies').html(freebies);

			self.handleUpdateFreeDelivery(total);

		} else if (oper == 'remove') {
			$('.navbar-cart').empty().append(data);
			$('.navbar-cart-quantity').html(parseInt(productsCount));
			$('.cart-summary').find('.cart-summary__total').find('span').text(total);
			$('.cart-positions-table-foot').find('.cart-positions-price').find('span').text(savings);
			$('.cart-positions-table-foot').find('.cart-positions-price').find('.savingsPercent').text(savingsPercent);
			$('.cart-summary__freedelivery').html(freeDelivery);
			$('.cart-right').html(cartRight);
			$('.cart-freebies').html(freebies);

			self.handleUpdateFreeDelivery(total);
		} else if (oper == 'update' || oper == 'refresh') {
			$('.navbar-cart').empty().append(data);
			$('.navbar-cart-quantity').html(parseInt(productsCount));
			$('.cart-summary').find('.cart-summary__total').find('span').text(total);
			$('.cart-positions-table-foot').find('.cart-positions-price').find('span').text(savings);
			$('.cart-positions-table-foot').find('.cart-positions-price').find('.savingsPercent').text(savingsPercent);
			$('.cart-summary__freedelivery').html(freeDelivery);
			$('.cart-positions-quantity').removeClass('-wait');
			$('.cart-right').html(cartRight);
			$('.cart-freebies').html(freebies);

			self.handleUpdateFreeDelivery(total);
		} else if (oper == 'country') {
			$('.cart-right').html(cartRight);
			$('.country-container').html(country);
		}

		if (productsCount == 0) {
			$('.cart-empty-info').addClass('-active');
		}

		$('.cart-to-checkout').find('.cart-total').find('.cart-total__sum').find('span').text(totalCheckout);

		self.handleMenuCartScroll();
		setTimeout(function() {
			$('.menu-cart .cart-positions').getNiceScroll().resize();
		}, 500);
	});
};

Cart.prototype.handleDeliveryRadio = function() {
	var self = this;

	$('body').on('click', '.w-form-formradioinput', function() {
		ajax_cart();
	});
	$('body').on('click', '.cart-shippment__country-change', function(e) {
		e.preventDefault();
		$('.country-container').addClass('-active');
		$(this).hide();
	});
};

Cart.prototype.handleAddToCartButtons = function() {
	var self = this;

	$('body').on('click', '.catalogue-item-icons__icon-cart', function(e) {
		e.preventDefault();
		// $('.cartadded-overlay').addClass('-active');
	});
};

Cart.prototype.handleRemoveButton = function() {
	var self = this;

	$('.cart .-remove-item').on('click', function(e) {
		e.preventDefault();
		var oper = 'remove';
		var attributes_id = $(this).closest('.cart-positions-table-row').attr('data-attributes_id');
		
		$(this).closest('.cart-positions-table-row').remove();

		self.updateCart(oper, attributes_id, 0);
	});
};

Cart.prototype.handleUpdateFreeDelivery = function(totalcost) {
	var self = this;

	var freeDeliveryVal = parseFloat($('.free-delivery-cart').attr('data-free-delivery-cost'));
	var totalCost = parseFloat(totalcost.replace(",","."));
	
	var finalCost = freeDeliveryVal.toFixed(2) - totalCost.toFixed(2);
	var finalCostStr = finalCost.toFixed(2).toString().replace(".",",");

	if(finalCost > 0) {
		$('.free-delivery-cart-content').html('Do darmowej <br> wysyłki brakuje <br> ci jeszcze ' + finalCostStr + ' zł');
	} else {
		$('.free-delivery-cart-content').html('Twoje zamówienie <br> zostanie wysłane <br> za darmo!');
	}
};

Cart.prototype.handleQuantityButtons = function() {
	var self = this;
	
	$('.cart-positions-quantity').each(function() {
		var that = this;
		//var input = $(this).find('input');
		//var val = input.val();
		//var initialVal = val;
		var singular_price = parseFloat($(that).siblings('.cart-positions-price').attr('data-price'));
		var total_container = $(that).siblings('.cart-positions-total').find('div');
		var total;
		var quantity;

		var attributes_id = $(this).closest('.cart-positions-table-row').attr('data-attributes_id');
		var oper = 'update';

		$(this).find('.plus').on('click', function() {
			var disabled = $(this).hasClass('disabled');
			//console.log('plus ' + (disabled ? "blokada" : ""));
			if (!disabled) {
				var input = $(that).find('input');
				var max_quantity = parseFloat($(that).closest('.shop-item').attr('data-max-quantity'));
				var val = parseInt( input.val() );
				val++;
				if (val > max_quantity) {
					val = max_quantity;
				}
				input.val(val);
				$(that).closest('.shop-item').attr('data-quantity', val);
				total = parseFloat(val*singular_price).toFixed(2);
				total_container.empty().text(total.replace(".",",")+' zł');
				quantity = 1;

				$(that).closest('.cart-positions-quantity').addClass('-wait');

				self.updateCart(oper, attributes_id, quantity);
			}
		});

		$(this).find('.minus').on('click', function() {
			var disabled = $(this).hasClass('disabled');
			//console.log('minus ' + (disabled ? "blokada" : ""));
			if (!disabled) {
				var input = $(that).find('input');
				var val = parseInt( input.val() );
				if (val > 1)
					val--;
				var max_quantity = parseFloat($(that).closest('.shop-item').attr('data-max-quantity'));
				if (val > max_quantity) {
					val = max_quantity;
				}
				input.val(val);
				$(that).closest('.shop-item').attr('data-quantity', val);
				total = parseFloat(val*singular_price).toFixed(2);
				total_container.empty().text(total.replace(".",",")+' zł');
				quantity = -1;

				$(that).closest('.cart-positions-quantity').addClass('-wait');

				self.updateCart(oper, attributes_id, quantity);
			}
		});
	});
};

Cart.prototype.handleQuantityInput = function() {
	var self = this;
	var disabled_send = true;
	$('body').on('blur', '.cart-positions-quantity__input', function() {
		var that = this;
		disabled_send = true;
		var attributes_id = parseInt($(this).closest('.shop-item').attr('data-attributes_id'));
		var actual_value = parseInt($(this).closest('.shop-item').attr('data-quantity'));
		var singular_price = parseFloat($(that).closest('.shop-item').attr('data-price'));
		var max_quantity = parseFloat($(that).closest('.shop-item').attr('data-max-quantity'));
		var total_container = $(that).closest('.shop-item').find('.cart-positions-total div');
		var quantity = 0;
		var oper = 'update';

		if (parseInt($(this).val()) > max_quantity) {
			$(this).val( max_quantity );
		}

		if (parseInt($(this).val()) > actual_value) {
			quantity = parseInt($(this).val()) - actual_value;
		} else if (parseInt($(this).val()) < actual_value && parseInt($(this).val()) !== 0) {
			quantity = -parseInt(actual_value - parseInt($(this).val()));
		} else if (parseInt($(this).val()) == actual_value || parseInt($(this).val() === 0)) {
			return;
		}
		
		var val = parseInt($(this).val());

		$(this).closest('.shop-item').attr('data-quantity', val);
		console.log("ilosc: " + val + " quantity: " + quantity + " actual_value " + actual_value + " attributes_id " + attributes_id);
		total = parseFloat(val*singular_price).toFixed(2);
		console.log("total " + total);
		total_container.empty().text(total.replace(".",",")+' zł');
		
		$(that).closest('.cart-positions-quantity').addClass('-wait');

		self.updateCart(oper, attributes_id, quantity);
	});			

	$('body').on('submit', '.cart-form', function(e) {
		console.log('submit');
		if (disabled_send) {
			e.preventDefault();
			$('.cart-positions-quantity__input').trigger('blur');
		}
	});

	$('body').on('click', '.discount_submit', function(e) {
		disabled_send = false;
		$(this).closest('form').submit();
	});

	$('body').on('keypress', '.cart-promocode-form__input', function(e){
		console.log('keypress');
		if (e.keyCode == 13) {
			disabled_send = false;
			$('.cart').submit();
		}
	});

	// $('.product-info').on('submit', '.shop-item__cart__form form', function(e) {
	// 	e.preventDefault();
	// });
};

Cart.prototype.addItems = function() {
	var self = this;
	$('body').on('click', '.button--add-to-cart-js', function(e) {
		e.preventDefault();
		var that = this;

		if ($(this).hasClass('lack')) {
			return false;
		}
		// var productMaxQuantity = parseInt($('.product-info').attr('data-quantity'));
		var quantity = 1;
		var attributes_id = $(this).attr('data-attributes_id'); //parseInt($(this).closest('.catalogue-item').attr('data-attributes_id'));
		// var cartItem = $('.cart-overlay').find('.shop-item[data-attributes_id="'+attributes_id+'"]');
		var oper = 'add';
		var span = $('.navbar-cart-quantity').text();
		if (span === '') {
			span = 0;
		}
		// if (isNaN(quantity)) {
		// 	quantity = 1;
		// } else {
		// 	if (parseInt(cartItem.attr('data-quantity')) >= productMaxQuantity) {
		// 		oper = 'update';
		// 		quantity = 0;
		// 	} else if (quantity + parseInt(cartItem.attr('data-quantity')) >= productMaxQuantity) {
		// 		oper = 'update';
		// 		quantity = productMaxQuantity - parseInt(cartItem.attr('data-quantity'));
		// 	}
		// }
		
		// $.ajaxSetup({
			// 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
		// });

		self.updateCart(oper, attributes_id, quantity, that);
	});
};

Cart.prototype.handleMenuCartScroll = function() {
	var self = this;
	$('.menu-cart .cart-positions').niceScroll({
		nativeparentscrolling: false,
		cursorcolor: "#D2373B",
		cursorwidth: "12px",
		background: "#ffffff",
		cursorborder: "0",
		cursorborderradius: 0,
		autohidemode: false,
	});
};

Cart.prototype.handleOrderInputs = function() {
	var self = this;
	var oldaddress = {
		address_street: "",
		address_street_number: "",
		address_home_number: "",
		zip: "",
		city: "",
		country: "",
	};
	var country = $('#cart-company-country').attr('data-delivery');
	$('#cart-address-fv-data').on('change', function() {
		if ($(this).is(':checked')) {
			$('.order-form-delivery1').removeClass('-active');
			$('#cart-company-country').attr('disabled','disabled');
			if ($('#cart-company-country').val() != country) {
				oldaddress.address_street = $('#cart-company-address_street').val();
				oldaddress.address_street_number = $('#cart-company-address_street_number').val();
				oldaddress.address_home_number = $('#cart-company-address_home_number').val();
				oldaddress.zip = $('#cart-company-zip').val();
				oldaddress.city = $('#cart-company-city').val();
				oldaddress.country = $('#cart-company-country').val();
				$('#cart-company-address_street').val("");
				$('#cart-company-address_street_number').val("");
				$('#cart-company-address_home_number').val("");
				$('#cart-company-zip').val("");
				$('#cart-company-city').val("");
				$('#cart-company-country').val(country);
			}
		} else {
			$('.order-form-delivery1').addClass('-active');
			$('#cart-company-country').removeAttr('disabled');
			if ($('#cart-company-country').val() == country && country != "PL") {
				$('#cart-company-address_street').val(oldaddress.address_street);
				$('#cart-company-address_street_number').val(oldaddress.address_street_number);
				$('#cart-company-address_home_number').val(oldaddress.address_home_number);
				$('#cart-company-zip').val(oldaddress.zip);
				$('#cart-company-city').val(oldaddress.city);
				$('#cart-company-country').val(oldaddress.country);
			}
		}
	});
	$('#cart-address-fv-data').change();

	$('#cart-fv').on('change', function() {
		if ($(this).is(':checked')) {
			$('.fv-active').addClass('-active');
		} else {
			$('.fv-active').removeClass('-active');
		}
	});
	$('#cart-fv').change();

	//$('.clear-country').on('click', function() {
	$('body').on('click', '.clear-country', function(e) {
		$('input[name=country]').val('');
		self.updateCart('country', 0, 0);
	});
};

//f-cja updateu koszyka jesli sie zmienil
function getCartHash() {
	$.ajax({
		method: 'POST',
		url: '/cart-hash',
		//dataType: 'json',
	}).success(function(getHash) {
		var lastHash = document.body.getAttribute('data-hash');
		if (getHash && getHash != lastHash) {
			//jesli na stronie koszyka to relad bo nie ma updatu js
			if ($('form[action="/koszyk"]').length)
				reloadAsGet();
			else
				cart.updateCart('refresh', 0, 0);
		}
	});
}

Cart.prototype.handleCheckout = function() {
    // Inicjacja płatności
    $('body').on('click', '.payment-method-select', function() {
        if (typeof fbq !== 'undefined') {
            fbq('track', 'InitiateCheckout');
        }
    });
    
    // Przejście do kasy
    $('body').on('click', '.proceed-to-checkout', function() {
        if (typeof fbq !== 'undefined') {
            fbq('track', 'AddPaymentInfo');
        }
    });
};